import { LoadingIndicator } from '@commenda/kakashi';
import { NumberFormat } from '@commenda/utils';
import { CorporationType, Prisma } from '@prisma/client';
import { DataPoint } from '../common/DataPoint';
import { useOwnershipInfo } from './useOwnershipInfo';

const SharesInformation = ({
  businessEntityId,
}: {
  businessEntityId: number;
}) => {
  const {
    isLoading: isOwnershipDataLoading,
    error: ownershipDataError,
    shareClassInformation,
    businessEntity,
  } = useOwnershipInfo({ businessEntityId });

  const businessEntityType = businessEntity?.businessEntityType;

  if (isOwnershipDataLoading) {
    if (ownershipDataError) console.error(ownershipDataError);

    return (
      <div className="flex flex-col gap-2xl">
        <h3 className="txt-large-bold">
          {businessEntityType === CorporationType.LLC
            ? 'Capital contributions'
            : 'Authorized shares'}
        </h3>
        <LoadingIndicator size={48} _className="mx-auto" />
      </div>
    );
  }

  const shareClassDataPoints = [
    {
      heading:
        businessEntityType === CorporationType.LLC
          ? 'Capital contributions'
          : 'Total Authorized Shares',
      value:
        NumberFormat.formatNumberWithCommas(
          shareClassInformation.totalAuthorizedShares
        ) || '-',
    },
    ...(businessEntityType !== CorporationType.LLC
      ? [
          {
            heading: 'Total Issued Shares',
            value:
              NumberFormat.formatNumberWithCommas(
                shareClassInformation.outstandingShares
              ) || '-',
          },
          {
            heading: 'ESOPs',
            value:
              shareClassInformation.esopPercentage !== undefined &&
              shareClassInformation.esopPercentage !== null
                ? `${new Prisma.Decimal(shareClassInformation.esopPercentage).toFixed(2)}%`
                : '-',
          },
        ]
      : []),
  ];

  return (
    <div className="flex flex-col gap-2xl">
      <h3 className="txt-large-bold">
        {businessEntityType === CorporationType.LLC
          ? 'Capital contributions'
          : 'Authorized shares'}
      </h3>
      <div className="flex flex-col border border-border-primary rounded-xl divide-y divide-border-primary bg-bg-primary overflow-clip">
        {shareClassDataPoints.map((dataPoint) => (
          <DataPoint
            key={dataPoint.heading}
            title={dataPoint.heading}
            value={dataPoint.value}
            hideAddAction
          />
        ))}
      </div>
    </div>
  );
};

export default SharesInformation;
